const base = '@@Containers/App/';

export const UPDATE_USER = `${base}UPDATE_USER`;
